import { type Command } from '@telespot/core';

/**
 * @group Workspaces
 * @category Payloads
 */
export interface DeleteWorkspaceDetail {
  workspaceId: string;
}

/**
 * @group Workspaces
 * @category Tokens
 */
export const DELETE_WORKSPACE = 'workspaces:delete';

/**
 * @group Workspaces
 * @category Commands
 */
export class DeleteWorkspace implements Command<typeof DELETE_WORKSPACE, DeleteWorkspaceDetail> {
  public readonly name = DELETE_WORKSPACE;

  constructor(public readonly details: Readonly<DeleteWorkspaceDetail>) {}
}
